import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import IconButton from "@mostrans/web-components/components/base/IconButton";
import Input from "@mostrans/web-components/components/base/Input";
import { Button, Card, CardContent, Icon, Typography } from "@mui/material";
import React, { useState } from "react";
import { useHistory } from "react-router";
import PopupCalendar from "../../../components/PopupCalendar";

function Header(props) {
  const {
    dataOpportunity,
    setCandidateNameValue,
    setCandidateEmailValue,
    setCandidatePhoneNumberValue,
    setCandidateSchoolValue,
    setCandidateMajorValue,
    setCandidateExperienceValue,
    setCandidateExperienceCompanyValue,
    setCandidateSkillValue,
    listCalendarInvitation,
  } = props;
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Card sx={{ display: "flex", flexDirection: "column" }}>
        <CardContent>
          <div className="form-row">
            <div className="col-md-6 gap-1">
              <Typography variant="h4" sx={{ fontWeight: 500 }}>
                <IconButton color="primary" onClick={() => history.goBack()}>
                  <Icon>arrow_back</Icon>
                </IconButton>
                Jobs Selected :{" "}
                <b className="text-primary-main">{dataOpportunity.title}</b>
              </Typography>
              <Typography
                variant="h6"
                sx={{ marginBottom: "-.5rem", marginLeft: "1.5rem" }}
              >
                <Button onClick={handleClick}>
                  <Icon
                    className="material-icons-outlined mr-1"
                    color="primary"
                  >
                    calendar_today
                  </Icon>
                  Calendar Invitation
                </Button>
              </Typography>
              <PopupCalendar
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                jobTitle={dataOpportunity.title}
                dataCandidates={listCalendarInvitation}
              />
            </div>
            <div className="col-md-6">
              <FormGroup placement="vertical">
                <Input
                  type="text"
                  placeholder="Search Candidate"
                  onChange={(e) => {
                    setCandidateNameValue(e.target.value);
                    setCandidateEmailValue(e.target.value);
                    setCandidatePhoneNumberValue(e.target.value);
                    setCandidateSchoolValue(e.target.value);
                    setCandidateMajorValue(e.target.value);
                    setCandidateExperienceValue(e.target.value);
                    setCandidateExperienceCompanyValue(e.target.value);
                    setCandidateSkillValue(e.target.value);
                  }}
                />
              </FormGroup>
            </div>
          </div>
        </CardContent>
      </Card>
    </React.Fragment>
  );
}

export default Header;
